/**
 * Find the DOM element under a viewport coordinate, skipping any
 * element that belongs to Hovercontext's own overlay.
 */
export const hitTest = (x, y, ignore) => {
    if (typeof document === "undefined")
        return null;
    const candidates = document.elementsFromPoint(x, y);
    for (const candidate of candidates) {
        if (shouldIgnore(candidate, ignore))
            continue;
        return candidate;
    }
    return null;
};
const shouldIgnore = (candidate, ignore) => {
    for (const ig of ignore) {
        if (ig === candidate)
            return true;
        if (ig.contains(candidate))
            return true;
    }
    return false;
};
export const isOwnEvent = (event, ignore) => {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];
    for (const node of path) {
        if (!(node instanceof Element))
            continue;
        for (const ig of ignore) {
            if (ig === node || ig.contains(node))
                return true;
        }
    }
    return false;
};
//# sourceMappingURL=hitTest.js.map